export default __webpack_public_path__ + "static/media/icon-arrow-right.91f57a6f.svg";